export const MAPBOX_ACCESS_TOKEN =
  'pk.eyJ1IjoiYmpkMjIwMiIsImEiOiJjbDJ0aWk1dmswNG94M2pxb3hpdDlvYTQyIn0.aIGpMlYw_OATj4nrHVLpVA';
export const GA_TRACKING_ID = 'UA-176566123-1';
